import api from "../utils/api";
import { isGuid } from "../utils/string";
import { LOGOUT } from "./types";

const BASE_URL = "/accounts/journals";

export const reverse = (uuid) => async (dispatch) => {
  try {
    if (!isGuid(uuid)) return { success: false, error: { message: "Invalid journal entry uuid." } };
    const res = await api.post(`${BASE_URL}/i/${uuid}/reverse`);
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};
